<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Tenant Admin Requests</span>
    </div>
    <h2 class="font-weight-medium mb-3 mb-md-4">Tenant Admin Requests</h2>

    <!-- work permit requests start -->
    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3 py-3 py-md-4 border-right border-light">
                <div class="form-group floating_form_field mb-0 w-100">
                    <select class="form-control border-0">
                        <option value="all">All</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                        <option value="declined">Declined</option>
                    </select>
                    <label>Approval Status</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 py-3 py-md-4 border-right border-light d-flex align-items-center">
                <div class="dp-hidden position-absolute">
                    <input name="datepicker" class="form-control" ngbDatepicker container="body"
                        #datepicker="ngbDatepicker" [autoClose]="'outside'" (dateSelect)="onDateSelection($event)"
                        [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!"
                        tabindex="-1" />
                    <ng-template #t let-date let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                </div>
                <svg-icon src="./assets/images/icons/calendar_cyan.svg" class="field_icon"></svg-icon>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input type="text" class="form-control border-0 datepicker_field" placeholder="Start Date"
                        #dpFromDate name="dpFromDate" [value]="formatter.format(fromDate)"
                        (input)="fromDate = validateInput(fromDate, dpFromDate.value)" (click)="datepicker.toggle()">
                    <label>Start Date</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 py-3 py-md-4 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/calendar_cyan.svg" class="field_icon"></svg-icon>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input type="text" class="form-control border-0 datepicker_field" placeholder="End Date" #dpToDate
                        name="dpToDate" [value]="formatter.format(toDate)"
                        (input)="toDate = validateInput(toDate, dpToDate.value)" (click)="datepicker.toggle()">
                    <label>End Date</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 py-3 py-md-4 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div class="form-group floating_form_field mb-0 w-100">
                    <select class="form-control border-0">
                        <option value="latest">Latest</option>
                        <option value="oldest">Oldest</option>
                    </select>
                    <label>Sort by</label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 py-3 py-md-4 d-flex align-items-center">
                <form class="search_form">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" class="search_field" placeholder="Search by Plant Name">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <h3 class="h6 font-weight-bold mb-4 mb-md-5 text-dark">{{workPermits.length}} Requests</h3>
    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let request of workPermits">
            <div class="bg-lighter p-3 rounded cursor-pointer" (click)="goToDetails(request.refNo)">
                <h3 class="font-weight-bold text-primary h5">Ref. No. {{request.refNo}}</h3>
                <p class="small mb-1">Tenant Name: {{request.tenantName}}</p>
                <p class="small mb-1">Company: {{request.company}}</p>
                <p class="small mb-1">Start Date: {{request.startDate}}</p>
                <p class="small mb-1">End Date: {{request.endDate}}</p>
                <p class="small mb-0">
                    <ng-container *ngIf="request.approvalStatus === ''; else approvalStatus">
                        <span class="font-weight-bold text-danger">Safety Documents Required</span>
                    </ng-container>
                    <ng-template #approvalStatus>
                        Approval Status: {{ request.approvalStatus }}
                    </ng-template>
                </p>
            </div>
        </div>
    </div>
    <!-- work permit requests end -->
    <div class="custom_pagination mt-4 mt-md-5 small">
        <div class="border border-light">
            <ngb-pagination [collectionSize]="1" [(page)]="page">
                <ng-template ngbPaginationPrevious>
                    <svg-icon src="./assets/images/icons/prev.svg"></svg-icon>
                </ng-template>
                <ng-template ngbPaginationNext>
                    <svg-icon src="./assets/images/icons/next.svg"></svg-icon>
                </ng-template>
            </ngb-pagination>
            <div class="page_numbers">
                {{page}}/{{totalPages}}
            </div>
        </div>
    </div>
</div>